import get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Notification from '../notification';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Search from '../search/search';
import matchMediaDesktop from '../../../utils/client_util';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import withTracking from '../../../utils/tracking/components/withTracking';
import {
  defaultClick,
  newsletterSubmit
} from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';
import axios from 'axios';
import LogoAnimation from './sap_animated_logo/sap_animated_logo';

class Nav extends Component {
  constructor() {
    super();

    this.state = {
      scale: false,
      menu: false,
      search: false,
      newsletterEmail: ''
    };

    this.setNavScale = this.setNavScale.bind(this);
    this.getCategoryData = this.getCategoryData.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenuIfOpen = this.closeMenuIfOpen.bind(this);
    this.renderCategoryLink = this.renderCategoryLink.bind(this);
    this.renderPageTitle = this.renderPageTitle.bind(this);

    // SAP Header related
    this.sapHeader = true;
    this.handleExpandSapSurveyTracking = this.handleExpandSapSurveyTracking.bind(
      this
    );
    this.handleCloseSapSurveyTracking = this.handleCloseSapSurveyTracking.bind(
      this
    );

    this.newsletterInput = React.createRef();
    this.newsletterInputMobile = React.createRef();
  }

  componentDidMount() {
    if (matchMediaDesktop() && !this.sapHeader) {
      window.addEventListener('scroll', this.setNavScale);
    }

    // Intiate logoAnimation
    if (this.shouldRenderSapHeader()) {
      this.logoAnimation = new LogoAnimation(
        this.handleExpandSapSurveyTracking,
        this.handleCloseSapSurveyTracking
      );
    }

    // Initiate queryly
    if (typeof window.queryly !== 'undefined') {
      const { queryly } = window;
      queryly.init(
        'c99eafd2993b450c',
        document.getElementsByClassName('queryly_search_button')
      );
    }
  }

  setNavScale() {
    const { scrollY } = window;
    const { scale } = this.state;
    const featureFlags = get(this.props, 'config.featureFlags');

    if (this.props.isHome && featureFlags.topNavAdEnabled) {
      this.setState({ scale: false });
    } else {
      if (scale && scrollY <= 20) {
        this.setState({ scale: false });
      }

      if (!scale && scrollY > 20) {
        this.setState({ scale: true });
      }
    }
  }

  getCategoryData(topic) {
    let className = 'nav__link';
    const active = topic.url === get(this.props, 'activeCategory');

    if (active) {
      className = ' nav__active';
    }

    return { className, active };
  }

  setHeaderClass(menu, isHome) {
    const featureFlags = get(this.props, 'config.featureFlags');
    let className = 'page-header';

    if (menu) {
      className += ' page-header--menu';
    }

    // For when we have homepage ad, manually add this for now for now
    if (isHome && featureFlags.topNavAdEnabled) {
      className += ' page-header--with-top-ad';
    }

    if (this.sapHeader) {
      className += ' has-sap-header';
    }
    return className;
  }

  toggleMenu(event) {
    const { menu } = this.state;
    const html = document.querySelector('html');
    const addRemove = menu ? 'remove' : 'add';
    this.setState({ menu: !menu, search: false });

    html.classList[addRemove]('no-scroll');

    if (event) {
      event.preventDefault();
    }
  }

  closeMenuIfOpen() {
    if (this.state.menu) {
      this.toggleMenu();
    }
  }

  handleLinkTracking(topic, index) {
    const { title } = topic;

    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Top Navigation Click',
      `nav${title}`,
      'siteNavigation',
      `navigation ${title}`,
      index + 1
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Interaction',
      eventAction: 'Top Nav Category',
      eventLabel: title
    });
  }

  handleFollowLinkTracking(network, index) {
    const { property } = network;

    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Top Nav Follow Us Click',
      `nav${property}`,
      'socialFollow',
      `socialNavigation ${property}`,
      index + 1
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Social',
      eventAction: 'Top Nav Follow Us',
      eventLabel: property
    });
  }

  handleExpandSapSurveyTracking() {
    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'FC-SAP Logo Uncollapse',
      `expandView`,
      'expand',
      `SAP survey expanded`,
      0
    );

    this.props.trackClick(clickEvent.getTrackingObject());
  }

  handleCloseSapSurveyTracking() {
    const clickEvent = new EventModel(
      'FC-SAP Logo collapse',
      `collapseSurvey`,
      'collapse',
      `SAP survey collapse`,
      0
    );

    this.props.trackClick(clickEvent.getTrackingObject());
  }

  shouldRenderSapHeader() {
    return false;
  }

  // Render the SAP SVG logo without link back to home
  renderSapAnimationLogo() {
    return (
      <h2>
        <svg
          className="js-fc-logo fc-logo"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 2750 164"
        >
          <title>Fast Company</title>
          <defs>
            <linearGradient
              x1="49.9985447%"
              y1="-0.0196078431%"
              x2="49.9985447%"
              y2="99.9803922%"
              id="sap-gradient"
            >
              <stop stopColor="#00B8F1" offset="0%" />
              <stop stopColor="#01B6F0" offset="1.644576%" />
              <stop stopColor="#0D90D9" offset="30.79%" />
              <stop stopColor="#1775C8" offset="57.82%" />
              <stop stopColor="#1C65BF" offset="81.73%" />
              <stop stopColor="#1E5FBB" offset="100%" />
            </linearGradient>

            <clipPath className="js-fc-sap-mask" id="sap-mask">
              <rect x="1660" y="0" width="290" height="90" />
            </clipPath>

            <filter
              id="fc-svg-filter-f"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-f"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-a1"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-a1"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-s"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-s"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-t"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-t"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-c"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-c"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-o"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-o"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-m"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-m"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-p"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-p"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-a2"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-a2"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-n"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-n"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>

            <filter
              id="fc-svg-filter-y"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                id="fc-gaussian-blur-y"
                in="SourceGraphic"
                stdDeviation="0"
              />
              <feOffset dx="0" dy="0" />
            </filter>
          </defs>

          <g className="js-fc-letter-group fc-letter-group">
            <g filter="url(#fc-svg-filter-f)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-f"
                d="M1133.68,51.97h1v-12.8H1085v0.86c5.73,4.65,6.52,6.01,6.52,11.1v61.99c0,5.08-0.79,6.44-6.52,11.09v0.86 h25.77v-0.86c-5.8-4.36-6.8-6.01-6.8-10.88V82.61h5.58c7.3,0,8.6,0.5,14.82,8.45h0.86V70.87h-0.86c-6.22,7.94-7.51,8.45-14.82,8.45 h-5.58V42.3h8.52C1115.93,42.3,1118.86,43.45,1133.68,51.97L1133.68,51.97z"
              />
            </g>

            <g filter="url(#fc-svg-filter-a1)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-a1"
                d="M1166.86,95.71L1166.86,95.71l-14.95-41.09h-13.54v0.79c1.9,1.77,3.13,3.12,4.09,4.61l-11.18,33.97 c-2,6.09-3.29,8.02-8.38,12.74v0.87h15.68v-0.86c-4.3-2.65-5.73-4.36-5.73-6.87c0-1.21,0.36-2.86,1.29-5.65l0.98-3.01h19.16 l1.75,4.86c1.08,3.09,1.29,4.37,1.29,5.52c0,1.78-1.22,3.29-4.51,5.15v0.87h21.9v-0.86 C1169.57,102.51,1168.79,101.08,1166.86,95.71z M1136.05,88.4l8.17-24.97c0.38,0.89,0.76,1.89,1.16,3.06l7.91,21.91H1136.05z"
              />
            </g>

            <g filter="url(#fc-svg-filter-s)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-s"
                d="M1199.76,51.97h1.01V39.59c-4.8-0.86-10.17-1.58-15.11-1.58c-14.4,0-21.48,9.6-21.48,19.83 c0,11.81,7.66,18.9,17.47,27.06c10.59,8.87,16.82,14.24,16.82,24.47c0,8.45-5.58,13.6-13.02,13.6c-6.52,0-11.67-2.58-25.35-13.32 h-1.2l5,13.96c6.01,1.69,12.23,2.56,18.48,2.58c16.39,0,25.91-9.95,25.91-23.76c0-12.74-7.45-19.25-18.05-27.85 c-9.73-7.88-16.39-14.25-16.39-23.41c0-5.94,3.94-10.02,10.03-10.02C1188.1,41.16,1191.03,42.81,1199.76,51.97L1199.76,51.97z"
              />
            </g>

            <g filter="url(#fc-svg-filter-t)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-t"
                d="M1262.83,51.97h1V39.15h-58.55v12.81h1c13.82-8.73,16.61-9.88,19.83-9.88h2.22v71.23 c0,4.87-1.01,6.52-6.81,10.88v0.86h26.06v-0.86c-5.8-4.36-6.8-6.01-6.8-10.88V42.09h2.22 C1246.22,42.09,1249.01,43.24,1262.83,51.97L1262.83,51.97z"
              />
            </g>

            <g filter="url(#fc-svg-filter-c)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-c"
                d="M1337.51,49.68h1.01V38.66c-5.8-0.86-13.25-1.57-20.04-1.57c-30.43,0-48.47,16.97-48.47,45.1 c0,27.64,17.25,44.74,47.32,44.74c7.8,0,14.82-1.14,20.41-2.65l2.21-12.24h-0.99c-11.24,9.52-16.25,11.74-24.41,11.74 c-22.48,0-30-16.97-30-42.09c0-25.56,7.52-41.16,28.78-41.16C1320.11,40.52,1324.92,42.09,1337.51,49.68L1337.51,49.68z"
              />
            </g>

            <g filter="url(#fc-svg-filter-o)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-o"
                d="M1323.16,55.47c-14.74,0-23.62,11.32-23.62,26.21c0,14.81,8.87,26.19,23.62,26.19 c14.75,0,23.62-11.38,23.62-26.19C1346.78,66.71,1337.9,55.47,1323.16,55.47z M1323.15,105.23c-10.31,0-11.46-9.37-11.46-23.55 c0-14.17,1.15-23.55,11.46-23.55c10.31,0,11.45,9.38,11.45,23.55S1333.4,105.23,1323.15,105.23z"
              />
            </g>

            <g filter="url(#fc-svg-filter-m)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-m"
                d="M1399.43,124.91l25.48,0.15v-0.86c-5.73-4.65-6.51-6.01-6.51-11.09V51.11c0-5.08,0.78-6.44,6.51-11.03v-0.86 l-18.04-0.14l-20.03,63.45l-20.49-63.38h-18.25v0.86c3.44,2.99,5.55,4.94,7.08,6.94v60.06c0,6.94-0.86,9.74-7.3,17.18v0.86h20.41 v-0.86c-8.6-7.08-9.81-9.95-9.81-17.18V53.58c0.14,0.41,0.28,0.8,0.42,1.25l22.99,70.94h1l23.04-73.02v60.27 c0,5.08-0.78,6.44-6.51,11.02C1399.43,124.05,1399.43,124.91,1399.43,124.91z"
              />
            </g>

            <g filter="url(#fc-svg-filter-p)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-p"
                d="M1456.73,91.41c16.18,0,29.78-6.88,29.78-26.56c0-19.33-13.53-25.7-31.85-25.7h-23.62v0.86 c5.72,4.65,6.51,6.01,6.51,11.1v61.99c0,5.08-0.79,6.44-6.51,11.09v0.86h25.77v-0.86c-5.8-4.36-6.8-6.01-6.8-10.88V91.41H1456.73z M1450.01,42.3h5.01c13.6,0,18.19,5.8,18.19,23.13c0,16.1-3.79,22.83-16.11,22.83h-7.09V42.3z"
              />
            </g>

            <g filter="url(#fc-svg-filter-a2)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-a2"
                d="M1518.76,124.2v0.86h23.51v-0.88c0,0.01-0.01,0.01-0.01,0.02c-3.96-4.96-4.82-7.34-6.82-14.39l-20.25-70.65 h-17.39v0.86c2.73,2.4,4.46,4.06,5.75,6.01l-16.85,60.64c-2.43,8.8-4.37,11.45-10.81,17.53v0.86h20.76v-0.86 c-5.94-4.51-7.8-6.8-7.8-10.74c0-1.57,0.36-3.8,1.22-6.79l2.69-9.74h26.11l3.63,12.81c1.14,4.01,1.57,5.73,1.57,7.3 C1524.06,119.26,1523.14,120.76,1518.76,124.2z M1517.95,93.71L1517.95,93.71l-24.31,0l11.98-43.3c0.25,0.74,0.5,1.53,0.76,2.42 L1517.95,93.71L1517.95,93.71L1517.95,93.71z"
              />
            </g>

            <g filter="url(#fc-svg-filter-n)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-n"
                d="M1603.01,39.16h-19.83v0.86c9.59,7.09,10.89,9.88,10.89,17.68v49.41l-35.86-67.95h-17.83v0.86 c3.72,3.19,5.88,5.18,7.73,7.65v59.56c0,6.47-0.72,9.29-5.84,16.95v0.88h20.02v-0.86c-9.6-7.08-10.88-9.88-10.88-16.97V53 c0.07,0.14,0.14,0.25,0.21,0.4l37.87,71.65h7.88V57.7c0-7.12,0.71-9.96,5.65-17.63V39.16z"
              />
            </g>

            <g filter="url(#fc-svg-filter-y)">
              <path
                className="js-fc-logo-letter"
                id="fc-logo-letter-y"
                d="M1663,39.16h-19.39v0.86c5.22,4.65,6.8,6.87,6.8,10.24c0,1.79-0.43,3.22-1.87,6.52l-11.13,26.04l-14.56-32.27 c-1.15-2.5-1.51-3.86-1.51-5.15c0-2.29,1.3-3.58,4.8-5.37v-0.86h-23.12v0.92c0-0.01,0.01-0.01,0.01-0.01 c3.22,3.9,5.27,7.18,7.93,13.13l15.46,34.16v25.97c0,4.86-1.01,6.52-6.8,10.88v0.86h26.06v-0.86c-5.8-4.36-6.8-6.01-6.8-10.88 V86.97l12.88-29.99c2.73-6.37,4.8-9.37,11.24-16.96l0,0V39.16z"
              />
            </g>
          </g>

          <g
            id="sap-logo"
            transform="translate(1700.000000, 37.000000)"
            clipPath="url(#sap-mask)"
          >
            <g transform="translate(110.000000, 0.000000)">
              <g id="Group">
                <g>
                  <polyline
                    id="Path"
                    fill="url(#sap-gradient)"
                    points="0 87.7853659 90.3234867 87.7853659 178.696611 0.214634146 0 0.214634146 0 87.7853659"
                  />
                  <path
                    d="M106.056417,16.6556097 L88.4598063,16.6556097 L88.4598063,58.08 L73.0736078,16.6556097 L57.8174334,16.6556097 L44.6849879,51.297561 C43.298063,42.5404878 34.1530267,39.5356097 27.0016949,37.3034146 C22.2774819,35.8009756 17.249879,33.5687805 17.2932204,31.1219513 C17.3365617,29.1043903 19.9803874,27.2585365 25.2680388,27.5160976 C28.8220339,27.6878049 31.942615,27.9882927 38.1404358,30.9502438 L44.2515738,20.3902438 C38.5738499,17.5141463 30.7290557,15.7112195 24.3145278,15.7112195 L24.2711865,15.7112195 C16.7731235,15.7112195 10.5319613,18.1151219 6.67457627,22.0643903 C3.9874092,24.8117073 2.51380145,28.3317073 2.47046005,32.2380487 C2.38377723,37.6039024 4.33414044,41.3814635 8.49491526,44.3863414 C12.005569,46.9190244 16.5130751,48.5931708 20.4571428,49.7951219 C25.3547215,51.297561 29.3421308,52.5853659 29.2987894,55.3756097 C29.2554479,56.4058537 28.8653753,57.3502438 28.1285715,58.08 C26.9150121,59.3248781 25.0513317,59.7970732 22.4508474,59.84 C17.466586,59.9258537 13.7825666,59.1531708 7.88813559,55.7190244 L2.47046005,66.4078049 C8.32154964,69.7131708 15.2995158,71.6448781 22.407506,71.6448781 L23.3176756,71.6448781 C29.4721549,71.5160976 34.4564165,69.7990244 38.4438257,66.622439 C38.6605327,66.4507317 38.8772397,66.2790244 39.0939467,66.0643903 L37.3169492,70.7434146 L53.3099274,70.7434146 L55.9970945,62.6731708 C58.8142857,63.617561 61.9782083,64.1326829 65.4021792,64.1326829 C68.6961259,64.1326829 71.816707,63.617561 74.5905569,62.7160976 L77.1910412,70.7004878 L103.239225,70.7004878 L103.239225,53.9590244 L108.916949,53.9590244 C122.656174,53.9590244 130.804358,47.0478049 130.804358,35.4146341 C130.761017,22.5795122 122.872881,16.6556097 106.056417,16.6556097 Z M65.4021792,52.1131708 C63.3651332,52.1131708 61.41477,51.7697562 59.7677966,51.1258537 L65.3588378,33.697561 L65.4455205,33.697561 L70.9065375,51.1687805 C69.2595642,51.7697562 67.3958837,52.1131708 65.4021792,52.1131708 Z M107.09661,42.1112195 L103.239225,42.1112195 L103.239225,28.0741463 L107.09661,28.0741463 C112.254237,28.0741463 116.371671,29.7912195 116.371671,34.9853659 C116.371671,40.3941463 112.254237,42.1112195 107.09661,42.1112195 L107.09661,42.1112195 Z"
                    id="Shape"
                    fill="#FFFFFF"
                  />
                </g>
                <path
                  d="M111.73414,81.9902438 C111.73414,79.3287805 113.771186,77.2682927 116.371671,77.2682927 C118.972155,77.2682927 121.009201,79.2858537 121.009201,81.9902438 C121.009201,84.737561 118.972155,86.7121951 116.371671,86.7121951 C113.771186,86.7551219 111.73414,84.737561 111.73414,81.9902438 Z M116.371671,87.6995122 C119.492252,87.6995122 122.136077,85.2956097 122.136077,82.0331708 C122.136077,78.7707317 119.492252,76.3668292 116.371671,76.3668292 C113.207748,76.3668292 110.563923,78.7707317 110.563923,82.0331708 C110.563923,85.2956097 113.25109,87.6995122 116.371671,87.6995122 Z M115.201453,82.462439 L116.371671,82.462439 L118.105327,85.2956097 L119.232203,85.2956097 L117.325182,82.4195122 C118.322034,82.2907317 119.058838,81.7756097 119.058838,80.6165854 C119.058838,79.3287805 118.278692,78.7707317 116.718402,78.7707317 L114.204601,78.7707317 L114.204601,85.2956097 L115.201453,85.2956097 L115.201453,82.462439 L115.201453,82.462439 Z M115.201453,81.6039024 L115.201453,79.5863414 L116.545036,79.5863414 C117.238499,79.5863414 117.975303,79.7151219 117.975303,80.5307317 C117.975303,81.5609756 117.238499,81.6039024 116.371671,81.6039024 L115.201453,81.6039024 Z"
                  id="Shape"
                  fill="#1E5FBB"
                />
              </g>
            </g>
            <polygon
              id="+"
              fill="#FFFFFF"
              points="41.0232559 45.3833719 0 45.3833719 0 43.4203233 41.0232559 43.4203233 41.0232559 2 42.9767441 2 42.9767441 43.4203233 84 43.4203233 84 45.3833719 42.9767441 45.3833719 42.9767441 87 41.0232559 87"
            />
          </g>
        </svg>
      </h2>
    );
  }

  renderCategoryLink(topic, index) {
    const { url, title, external } = topic;
    const data = this.getCategoryData(topic);
    const attrs = {
      className: data.className,
      title
    };

    if (data.active) {
      return <span {...attrs}>{title}</span>;
    }

    if (external) {
      attrs.href = `//${url}`;
      return (
        <a
          {...attrs}
          onClick={() => {
            // trackGAEvent({
            //   eventCategory: 'Interaction',
            //   eventAction: 'Top Nav Category',
            //   eventLabel: title
            // });
            this.handleLinkTracking(topic, index);
          }}
        >
          {title}
        </a>
      );
    }
    attrs.to = url;
    return (
      <Link
        {...attrs}
        onClick={() => {
          // trackGAEvent({
          //   eventCategory: 'Interaction',
          //   eventAction: 'Top Nav Category',
          //   eventLabel: title
          // });
          this.handleLinkTracking(topic, index);
        }}
      >
        {title}
      </Link>
    );
  }

  renderSapBar() {
    return (
      <button className="nav__sap-bar js-sap-bar">
        <span className="nav__sap-bar__inner">
          <span className="nav__sap-bar__text">
            Fast Company and SAP are building a better web experience — and your
            opinion matters.
            <svg
              height="10"
              viewBox="0 0 11 10"
              width="11"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m5.5 9.5s-.63926241-3.08588144-2.46156542-5.800035c-1.41364811-2.10570793-2.53843458-3.199965-2.53843458-3.199965h10s-1.12456747 1.09425707-2.53821558 3.199965c-1.82230301 2.71415356-2.46178442 5.800035-2.46178442 5.800035z" />
            </svg>
          </span>
        </span>
      </button>
    );
  }

  renderSapSurvey() {
    return (
      <div className="nav__sap-survey js-sap-survey">
        <div className="nav__sap-survey__inner">
          <div class="nav__sap-survey__button-container">
            <button className="nav__sap-survey__close js-close-survey">
              Collapse
              <svg
                height="10"
                viewBox="0 0 11 10"
                width="11"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m5.5 9.5s-.63926241-3.08588144-2.46156542-5.800035c-1.41364811-2.10570793-2.53843458-3.199965-2.53843458-3.199965h10s-1.12456747 1.09425707-2.53821558 3.199965c-1.82230301 2.71415356-2.46178442 5.800035-2.46178442 5.800035z" />
              </svg>
            </button>
          </div>
          <div className="nav__sap-survey__left">
            <div className="nav__sap-survey__title">
              The Fast Company<br />Experience
              <svg
                className="nav__sap-survey__svg"
                width="43px"
                height="32px"
                viewBox="0 0 43 32"
                version="1.1"
              >
                <defs>
                  <linearGradient
                    x1="49.9966239%"
                    y1="0.0298219585%"
                    x2="49.9966239%"
                    y2="100.0273%"
                    id="linearGradient-1"
                  >
                    <stop stopColor="#00B8F1" offset="0%" />
                    <stop stopColor="#01B6F0" offset="1.644576%" />
                    <stop stopColor="#0D90D9" offset="30.79%" />
                    <stop stopColor="#1775C8" offset="57.82%" />
                    <stop stopColor="#1C65BF" offset="81.73%" />
                    <stop stopColor="#1E5FBB" offset="100%" />
                  </linearGradient>
                </defs>
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g id="SAP_powered_by_grad_R_min_v2">
                    <path
                      d="M28.5014749,29.4925373 C28.5014749,28.3134328 29.3716814,27.4179104 30.5073746,27.4179104 C31.6283186,27.4179104 32.4985251,28.3134328 32.4985251,29.4925373 C32.4985251,30.7014925 31.6135693,31.5820896 30.5073746,31.5820896 C29.3716814,31.5820896 28.5014749,30.6865672 28.5014749,29.4925373 Z M30.5073746,32 C31.8495575,32 33,30.9402985 33,29.4925373 C33,28.0597015 31.8495575,27 30.5073746,27 C29.1504425,27 28,28.0597015 28,29.4925373 C28,30.9253731 29.1504425,32 30.5073746,32 Z M29.9764012,29.6865672 L30.4778761,29.6865672 L31.2300885,30.9402985 L31.7168142,30.9402985 L30.9056047,29.6716418 C31.3185841,29.6268657 31.6430678,29.4029851 31.6430678,28.880597 C31.6430678,28.3134328 31.3038348,28.0597015 30.640118,28.0597015 L29.5486726,28.0597015 L29.5486726,30.9402985 L29.9764012,30.9402985 L29.9764012,29.6865672 Z M29.9764012,29.3134328 L29.9764012,28.4179104 L30.5663717,28.4179104 C30.8613569,28.4179104 31.1858407,28.4776119 31.1858407,28.8358209 C31.1858407,29.2835821 30.8613569,29.2985075 30.5073746,29.2985075 L29.9764012,29.2985075 L29.9764012,29.3134328 Z"
                      id="Shape"
                      fill="#1E5FBB"
                    />
                    <polygon
                      id="Path"
                      fill="url(#linearGradient-1)"
                      points="0 32 21.2234862 32 42 11 0 11"
                    />
                    <path
                      d="M25.2178629,15.2113821 L21.1074843,15.2113821 L21.1074843,24.844367 L17.5185716,15.2113821 L13.9603334,15.2113821 L10.8928867,23.2590012 C10.5708047,21.2357724 8.43892927,20.5261324 6.75183356,19.9976771 C5.64755274,19.6504065 4.46658574,19.1370499 4.48192298,18.5632985 C4.49726021,18.0952381 5.11074956,17.6573751 6.33772825,17.7328688 C7.16593887,17.7781649 7.90212609,17.8385598 9.34382605,18.533101 L10.7701888,16.087108 C9.45118669,15.4227642 7.61071865,15 6.10766975,15 L6.09233251,15 C4.34388787,15 2.88685068,15.5586527 1.98195389,16.4796748 C1.35312731,17.1289199 1.01570817,17.9442509 1.00037093,18.8350755 C0.9850337,20.0731707 1.44515071,20.9639954 2.41139643,21.6585366 C3.23960705,22.2473868 4.28253894,22.6399535 5.20277296,22.9117305 C6.33772825,23.2590012 7.27329951,23.5609756 7.27329951,24.2102207 C7.25796227,24.4518002 7.1812761,24.6631823 6.9972293,24.844367 C6.70582186,25.1312427 6.27637932,25.2369338 5.6782272,25.2520325 C4.51259744,25.28223 3.65371236,25.1010453 2.27336133,24.300813 L1.00037093,26.7770035 C2.36538473,27.5470383 3.9911315,28 5.66288997,28 L5.87761124,28 C7.31931121,27.9698026 8.48494097,27.5772358 9.42051222,26.8373984 C9.48186116,26.7921022 9.52787286,26.746806 9.57388456,26.7166086 L9.15977925,27.8037166 L12.9020643,27.8037166 L13.5308908,25.931475 C14.1903919,26.1579559 14.9419163,26.2787456 15.7241153,26.2787456 C16.4909769,26.2787456 17.2271642,26.1579559 17.871328,25.9616725 L18.4694801,27.8188153 L24.5583619,27.8188153 L24.5583619,23.9384437 L25.8927012,23.9384437 C29.098183,23.9384437 31,22.3228804 31,19.6353078 C31,16.5853659 29.1441947,15.2113821 25.2178629,15.2113821 L25.2178629,15.2113821 Z M15.708778,23.4552846 C15.2333238,23.4552846 14.7732068,23.3797909 14.3897759,23.2288037 L15.6934408,19.1823461 L15.7241153,19.1823461 L17.0124429,23.2439024 C16.6136748,23.3646922 16.1842323,23.4552846 15.708778,23.4552846 L15.708778,23.4552846 Z M25.4632586,21.1149826 L24.5583619,21.1149826 L24.5583619,17.8536585 L25.4632586,17.8536585 C26.6749001,17.8536585 27.6411458,18.2462253 27.6411458,19.4692218 C27.6258086,20.7224158 26.6749001,21.1149826 25.4632586,21.1149826 L25.4632586,21.1149826 Z"
                      id="Shape"
                      fill="#FFFFFF"
                    />
                    <g id="Group" fill="#181716" fillRule="nonzero">
                      <path
                        d="M0.0784671533,6.18039216 L0.0784671533,0.109803922 L2.13430657,0.109803922 C2.46386861,0.109803922 2.7620438,0.141176471 3.02883212,0.203921569 C3.29562044,0.266666667 3.5310219,0.376470588 3.71934307,0.517647059 C3.90766423,0.658823529 4.06459854,0.831372549 4.15875912,1.05098039 C4.26861314,1.27058824 4.31569343,1.5372549 4.31569343,1.83529412 C4.31569343,2.14901961 4.25291971,2.43137255 4.14306569,2.65098039 C4.03321168,2.87058824 3.87627737,3.05882353 3.67226277,3.2 C3.46824818,3.34117647 3.23284672,3.45098039 2.96605839,3.51372549 C2.69927007,3.57647059 2.40109489,3.60784314 2.07153285,3.60784314 L0.784671533,3.60784314 L0.784671533,6.18039216 L0.0784671533,6.18039216 Z M0.800364964,2.96470588 L2.13430657,2.96470588 C2.62080292,2.96470588 2.99744526,2.88627451 3.24854015,2.71372549 C3.49963504,2.54117647 3.62518248,2.25882353 3.62518248,1.85098039 C3.62518248,1.45882353 3.49963504,1.17647059 3.24854015,1.00392157 C2.99744526,0.831372549 2.62080292,0.752941176 2.11861314,0.752941176 L0.800364964,0.752941176 L0.800364964,2.96470588 Z"
                        id="Shape"
                      />
                      <path
                        d="M6.62262774,6.2745098 C6.35583942,6.2745098 6.10474453,6.22745098 5.86934307,6.13333333 C5.61824818,6.03921569 5.41423358,5.89803922 5.22591241,5.70980392 C5.03759124,5.52156863 4.89635036,5.28627451 4.78649635,5.00392157 C4.67664234,4.72156863 4.61386861,4.39215686 4.61386861,4.01568627 C4.61386861,3.63921569 4.66094891,3.30980392 4.77080292,3.04313725 C4.88065693,2.76078431 5.02189781,2.5254902 5.21021898,2.3372549 C5.39854015,2.14901961 5.61824818,2.00784314 5.85364964,1.91372549 C6.10474453,1.81960784 6.35583942,1.77254902 6.62262774,1.77254902 C6.88941606,1.77254902 7.14051095,1.81960784 7.37591241,1.91372549 C7.6270073,2.00784314 7.8310219,2.14901961 8.01934307,2.3372549 C8.20766423,2.5254902 8.34890511,2.76078431 8.45875912,3.04313725 C8.56861314,3.3254902 8.61569343,3.65490196 8.61569343,4.01568627 C8.61569343,4.39215686 8.56861314,4.72156863 8.45875912,5.00392157 C8.34890511,5.28627451 8.20766423,5.52156863 8.01934307,5.70980392 C7.8310219,5.89803922 7.61131387,6.03921569 7.37591241,6.13333333 C7.14051095,6.22745098 6.88941606,6.2745098 6.62262774,6.2745098 L6.62262774,6.2745098 Z M6.62262774,5.6627451 C6.82664234,5.6627451 7.0149635,5.61568627 7.17189781,5.5372549 C7.32883212,5.45882353 7.47007299,5.34901961 7.57992701,5.20784314 C7.68978102,5.06666667 7.78394161,4.89411765 7.8310219,4.6745098 C7.89379562,4.47058824 7.90948905,4.23529412 7.90948905,4 C7.90948905,3.78039216 7.87810219,3.56078431 7.8310219,3.35686275 C7.78394161,3.15294118 7.68978102,2.98039216 7.59562044,2.83921569 C7.48576642,2.68235294 7.36021898,2.57254902 7.18759124,2.47843137 C7.03065693,2.38431373 6.82664234,2.35294118 6.62262774,2.35294118 C6.41861314,2.35294118 6.23029197,2.4 6.07335766,2.47843137 C5.91642336,2.55686275 5.77518248,2.66666667 5.66532847,2.80784314 C5.55547445,2.94901961 5.46131387,3.12156863 5.41423358,3.3254902 C5.35145985,3.52941176 5.32007299,3.74901961 5.32007299,4 C5.32007299,4.23529412 5.35145985,4.43921569 5.39854015,4.64313725 C5.44562044,4.84705882 5.53978102,5.01960784 5.63394161,5.16078431 C5.74379562,5.30196078 5.86934307,5.42745098 6.0419708,5.50588235 C6.21459854,5.61568627 6.40291971,5.6627451 6.62262774,5.6627451 L6.62262774,5.6627451 Z"
                        id="Shape"
                      />
                      <path
                        d="M10.4047445,6.18039216 L9.08649635,1.85098039 L9.82408759,1.85098039 L10.3890511,3.89019608 C10.420438,4.01568627 10.4675182,4.14117647 10.4989051,4.26666667 C10.530292,4.37647059 10.5616788,4.50196078 10.5930657,4.61176471 C10.6244526,4.72156863 10.6558394,4.84705882 10.6872263,4.95686275 C10.7186131,5.08235294 10.75,5.20784314 10.7813869,5.34901961 L10.7970803,5.34901961 C10.8284672,5.19215686 10.8755474,5.06666667 10.9069343,4.94117647 C10.9383212,4.81568627 10.969708,4.70588235 10.9854015,4.59607843 C11.0167883,4.48627451 11.0481752,4.37647059 11.079562,4.26666667 C11.1109489,4.15686275 11.1423358,4.03137255 11.1894161,3.90588235 L11.7386861,1.88235294 L12.3507299,1.88235294 L12.9156934,3.95294118 C12.9627737,4.07843137 12.9941606,4.20392157 13.0255474,4.31372549 C13.0569343,4.42352941 13.0883212,4.53333333 13.119708,4.64313725 C13.1510949,4.75294118 13.1824818,4.8627451 13.1981752,4.97254902 C13.229562,5.08235294 13.2609489,5.22352941 13.2923358,5.36470588 L13.3080292,5.36470588 C13.3551095,5.22352941 13.3864964,5.09803922 13.4178832,4.97254902 C13.4492701,4.8627451 13.4806569,4.75294118 13.4963504,4.64313725 C13.5277372,4.53333333 13.5591241,4.42352941 13.5905109,4.31372549 C13.6218978,4.20392157 13.6532847,4.09411765 13.700365,3.96862745 L14.2967153,1.88235294 L14.9558394,1.88235294 L13.6375912,6.21176471 L12.9784672,6.21176471 L12.0525547,2.82352941 L12.0368613,2.82352941 L11.1109489,6.21176471 L10.4047445,6.21176471 L10.4047445,6.18039216 Z"
                        id="Path"
                      />
                      <path
                        d="M17.2941606,6.2745098 C17.0273723,6.2745098 16.7919708,6.22745098 16.5565693,6.13333333 C16.3211679,6.03921569 16.1171533,5.89803922 15.9288321,5.70980392 C15.7562044,5.52156863 15.5992701,5.28627451 15.4894161,5.00392157 C15.379562,4.72156863 15.3324818,4.39215686 15.3324818,4.01568627 C15.3324818,3.62352941 15.3952555,3.27843137 15.5051095,2.99607843 C15.6149635,2.71372549 15.7718978,2.47843137 15.960219,2.29019608 C16.1485401,2.10196078 16.3682482,1.97647059 16.5879562,1.88235294 C16.8233577,1.78823529 17.0587591,1.75686275 17.2784672,1.75686275 C17.529562,1.75686275 17.7649635,1.80392157 17.9846715,1.89803922 C18.2043796,1.99215686 18.3927007,2.13333333 18.549635,2.32156863 C18.7065693,2.50980392 18.8321168,2.74509804 18.9262774,3.04313725 C19.020438,3.3254902 19.0675182,3.67058824 19.0675182,4.0627451 L19.0675182,4.20392157 L16.0072993,4.20392157 C16.0072993,4.45490196 16.0543796,4.6745098 16.1171533,4.8627451 C16.1956204,5.05098039 16.289781,5.20784314 16.399635,5.33333333 C16.5094891,5.45882353 16.6507299,5.55294118 16.8076642,5.61568627 C16.9645985,5.67843137 17.1372263,5.70980392 17.309854,5.70980392 C17.6237226,5.70980392 17.8748175,5.64705882 18.0788321,5.5372549 C18.2828467,5.41176471 18.4554745,5.23921569 18.6281022,5.01960784 L19.0361314,5.38039216 C18.8321168,5.67843137 18.5967153,5.89803922 18.3142336,6.05490196 C18.0474453,6.18039216 17.7021898,6.2745098 17.2941606,6.2745098 L17.2941606,6.2745098 Z M18.4240876,3.63921569 C18.3927007,3.24705882 18.2985401,2.93333333 18.110219,2.69803922 C17.9218978,2.4627451 17.6551095,2.3372549 17.2941606,2.3372549 C17.1372263,2.3372549 16.9959854,2.36862745 16.870438,2.41568627 C16.7291971,2.4627451 16.6036496,2.54117647 16.4937956,2.65098039 C16.3839416,2.76078431 16.289781,2.88627451 16.2113139,3.05882353 C16.1328467,3.21568627 16.0857664,3.41960784 16.0543796,3.63921569 L18.4240876,3.63921569 Z"
                        id="Shape"
                      />
                      <path
                        d="M20.1189781,6.18039216 L20.1189781,1.85098039 L20.8251825,1.85098039 L20.8251825,2.65098039 L20.8408759,2.65098039 C20.9978102,2.4 21.2175182,2.18039216 21.4843066,2.02352941 C21.7510949,1.85098039 22.0963504,1.77254902 22.520073,1.77254902 L22.6142336,1.77254902 L22.5671533,2.43137255 C22.5514599,2.43137255 22.520073,2.41568627 22.4572993,2.41568627 L22.3631387,2.41568627 C22.0178832,2.41568627 21.719708,2.49411765 21.4529197,2.66666667 C21.2018248,2.83921569 20.9821168,3.0745098 20.8251825,3.38823529 L20.8251825,6.18039216 L20.1189781,6.18039216 Z"
                        id="Path"
                      />
                      <path
                        d="M24.889781,6.2745098 C24.6229927,6.2745098 24.3875912,6.22745098 24.1521898,6.13333333 C23.9167883,6.03921569 23.7127737,5.89803922 23.5244526,5.70980392 C23.3518248,5.52156863 23.1948905,5.28627451 23.0850365,5.00392157 C22.9751825,4.72156863 22.9281022,4.39215686 22.9281022,4.01568627 C22.9281022,3.62352941 22.9908759,3.27843137 23.1007299,2.99607843 C23.2105839,2.71372549 23.3675182,2.47843137 23.5558394,2.29019608 C23.7441606,2.10196078 23.9638686,1.97647059 24.1835766,1.88235294 C24.4189781,1.78823529 24.6543796,1.75686275 24.8740876,1.75686275 C25.1251825,1.75686275 25.3605839,1.80392157 25.580292,1.89803922 C25.8,1.99215686 25.9883212,2.13333333 26.1452555,2.32156863 C26.3021898,2.50980392 26.4277372,2.74509804 26.5218978,3.04313725 C26.6160584,3.3254902 26.6631387,3.67058824 26.6631387,4.0627451 L26.6631387,4.20392157 L23.6029197,4.20392157 C23.6029197,4.45490196 23.65,4.6745098 23.7127737,4.8627451 C23.7912409,5.05098039 23.8854015,5.20784314 23.9952555,5.33333333 C24.1051095,5.45882353 24.2463504,5.55294118 24.4032847,5.61568627 C24.560219,5.67843137 24.7328467,5.70980392 24.9054745,5.70980392 C25.2193431,5.70980392 25.470438,5.64705882 25.6744526,5.5372549 C25.8784672,5.41176471 26.0510949,5.23921569 26.2237226,5.01960784 L26.6317518,5.38039216 C26.4277372,5.67843137 26.1923358,5.89803922 25.909854,6.05490196 C25.6430657,6.18039216 25.2978102,6.2745098 24.889781,6.2745098 L24.889781,6.2745098 Z M26.019708,3.63921569 C25.9883212,3.24705882 25.8941606,2.93333333 25.7058394,2.69803922 C25.5175182,2.4627451 25.2507299,2.3372549 24.889781,2.3372549 C24.7328467,2.3372549 24.5916058,2.36862745 24.4660584,2.41568627 C24.3248175,2.4627451 24.1992701,2.54117647 24.0894161,2.65098039 C23.979562,2.76078431 23.8854015,2.88627451 23.8069343,3.05882353 C23.7284672,3.21568627 23.6813869,3.41960784 23.65,3.63921569 L26.019708,3.63921569 Z"
                        id="Shape"
                      />
                      <path
                        d="M29.2211679,6.24313725 C28.970073,6.24313725 28.7346715,6.19607843 28.5306569,6.10196078 C28.3109489,6.00784314 28.1226277,5.88235294 27.9656934,5.69411765 C27.8087591,5.50588235 27.6832117,5.28627451 27.5890511,5.00392157 C27.4948905,4.72156863 27.4478102,4.39215686 27.4478102,4.01568627 C27.4478102,3.63921569 27.4948905,3.30980392 27.5890511,3.02745098 C27.6832117,2.74509804 27.8087591,2.50980392 27.9813869,2.32156863 C28.1383212,2.13333333 28.3423358,1.99215686 28.5620438,1.89803922 C28.7817518,1.80392157 29.0328467,1.75686275 29.299635,1.75686275 C29.5664234,1.75686275 29.8018248,1.81960784 30.0372263,1.92941176 C30.2726277,2.03921569 30.4766423,2.19607843 30.6335766,2.4 L30.6335766,0.109803922 L31.339781,0.109803922 L31.339781,5.11372549 C31.339781,5.38039216 31.3554745,5.58431373 31.3711679,5.75686275 C31.3868613,5.92941176 31.4182482,6.07058824 31.4810219,6.18039216 L30.7591241,6.18039216 C30.7277372,6.10196078 30.7120438,6.00784314 30.6806569,5.89803922 C30.6649635,5.78823529 30.6492701,5.67843137 30.6492701,5.56862745 C30.4766423,5.75686275 30.2726277,5.92941176 30.0529197,6.05490196 C29.8332117,6.18039216 29.5507299,6.24313725 29.2211679,6.24313725 L29.2211679,6.24313725 Z M29.3937956,5.6627451 C29.6448905,5.6627451 29.8645985,5.6 30.0686131,5.4745098 C30.2726277,5.34901961 30.4609489,5.19215686 30.6492701,4.98823529 L30.6492701,2.99607843 C30.4609489,2.79215686 30.2569343,2.61960784 30.0529197,2.50980392 C29.8489051,2.4 29.6291971,2.3372549 29.3937956,2.3372549 C29.0171533,2.3372549 28.7189781,2.47843137 28.4835766,2.74509804 C28.2638686,3.01176471 28.1540146,3.43529412 28.1540146,4.01568627 C28.1540146,4.29803922 28.1854015,4.53333333 28.2481752,4.7372549 C28.3109489,4.94117647 28.3894161,5.11372549 28.4992701,5.23921569 C28.6091241,5.38039216 28.7346715,5.4745098 28.8916058,5.5372549 C29.0642336,5.63137255 29.2211679,5.6627451 29.3937956,5.6627451 L29.3937956,5.6627451 Z"
                        id="Shape"
                      />
                      <path
                        d="M36.5970803,6.24313725 C36.330292,6.24313725 36.0791971,6.18039216 35.8594891,6.07058824 C35.639781,5.96078431 35.4357664,5.80392157 35.2474453,5.61568627 L35.2474453,6.18039216 L34.5412409,6.18039216 L34.5412409,0.109803922 L35.2474453,0.109803922 L35.2474453,2.4627451 C35.4043796,2.2745098 35.6083942,2.11764706 35.8437956,1.97647059 C36.0791971,1.83529412 36.3459854,1.77254902 36.6755474,1.77254902 C36.9266423,1.77254902 37.1463504,1.81960784 37.3660584,1.91372549 C37.5857664,2.00784314 37.7740876,2.14901961 37.9310219,2.3372549 C38.0879562,2.5254902 38.2135036,2.76078431 38.3076642,3.04313725 C38.4018248,3.3254902 38.4489051,3.65490196 38.4489051,4.03137255 C38.4489051,4.40784314 38.4018248,4.7372549 38.3076642,5.01960784 C38.2135036,5.30196078 38.0879562,5.5372549 37.9153285,5.70980392 C37.7583942,5.89803922 37.5543796,6.02352941 37.3346715,6.11764706 C37.0992701,6.19607843 36.8638686,6.24313725 36.5970803,6.24313725 L36.5970803,6.24313725 Z M36.5029197,5.6627451 C36.879562,5.6627451 37.1777372,5.5372549 37.3974453,5.27058824 C37.6171533,5.00392157 37.7270073,4.58039216 37.7270073,4.01568627 C37.7270073,3.46666667 37.6171533,3.04313725 37.3817518,2.77647059 C37.1463504,2.50980392 36.8638686,2.36862745 36.5029197,2.36862745 C36.2518248,2.36862745 36.0164234,2.43137255 35.8124088,2.55686275 C35.6083942,2.68235294 35.420073,2.83921569 35.2317518,3.04313725 L35.2317518,5.03529412 C35.639781,5.44313725 36.0478102,5.6627451 36.5029197,5.6627451 L36.5029197,5.6627451 Z"
                        id="Shape"
                      />
                      <path
                        d="M39.500365,7.84313725 C39.3120438,7.84313725 39.1551095,7.82745098 39.0138686,7.81176471 C38.8883212,7.79607843 38.7784672,7.76470588 38.6843066,7.73333333 L38.8569343,7.16862745 C38.919708,7.18431373 38.9981752,7.2 39.1080292,7.21568627 C39.2178832,7.23137255 39.3434307,7.24705882 39.500365,7.24705882 C39.720073,7.24705882 39.8927007,7.2 40.0182482,7.10588235 C40.1437956,7.01176471 40.2379562,6.85490196 40.3321168,6.63529412 L40.5047445,6.21176471 L38.8255474,1.85098039 L39.5788321,1.85098039 L40.85,5.34901961 L40.8656934,5.34901961 L42.1368613,1.85098039 L42.8587591,1.85098039 L41.0069343,6.68235294 C40.9284672,6.87058824 40.85,7.04313725 40.7715328,7.18431373 C40.6930657,7.3254902 40.5989051,7.45098039 40.4733577,7.54509804 C40.3635036,7.63921569 40.2222628,7.71764706 40.0810219,7.76470588 C39.9083942,7.81176471 39.720073,7.84313725 39.500365,7.84313725 L39.500365,7.84313725 Z"
                        id="Path"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>

            <span className="nav__sap-survey__text">
              Fast Company, powered by SAP Experience Management solutions, is
              building a better web experience - and your opinion matters.
            </span>
          </div>
          <div className="nav__sap-survey__right">
            <iframe
              width="100%"
              height="450px"
              className="nav__sap-survey__iframe"
              src="https://inc.qualtrics.com/jfe/form/SV_8kzXqr6v5TmI1Jb"
            />
          </div>
        </div>
      </div>
    );
  }

  renderPageTitle() {
    const { isHome, title } = this.props;
    const { scale } = this.state;
    let className = 'page-header__title';

    if (scale) {
      className += ' page-header__title--scaled';
    }

    if (isHome) {
      return <h2 className={className}>{title}</h2>;
    }

    return (
      <Link to="/" className={className}>
        {title}
      </Link>
    );
  }

  render() {
    const {
      notification,
      isHome,
      topics,
      config,
      topNewsletterSignup
      // newsletterLink,
      // subscribeLink
    } = this.props;
    const { menu, search, scale } = this.state;
    const site = get(config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);
    const title = this.shouldRenderSapHeader()
      ? this.renderSapAnimationLogo()
      : this.renderPageTitle();
    const sapBar = this.shouldRenderSapHeader() ? this.renderSapBar() : '';
    const sapSurvey = this.shouldRenderSapHeader()
      ? this.renderSapSurvey()
      : '';

    // When we want to A/B test this link

    return (
      <header
        className={this.setHeaderClass(menu, isHome)}
        onClick={this.closeMenuIfOpen}
      >
        {sapBar}

        <div className="nav__main-items">
          {title}

          <ul
            className={`nav__extras nav__extras--left ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <a
              className={scale ? 'nav__menu__scaled' : 'nav__menu'}
              onClick={this.toggleMenu}
            >
              <img
                src="https://images.fastcompany.net/image/upload/v1540915228/fcweb/3_Line_Burger_ffffff2x_tiojxh.svg"
                className="nav__menu__hamburger"
                alt="Menu"
              />
            </a>

            {/* <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a className="nav__newsletter" href={newsletterLink}>
                Newsletter
              </a>
            </li>
            <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a href={subscribeLink} className="nav__subscribe">
                Subscribe
              </a>
            </li> */}
          </ul>

          <ul
            className={`nav__extras nav__extras--right ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <li className="nav__extras-item">
              {social.map((network, index) => (
                <a
                  key={network.url}
                  href={network.url}
                  className={`nav__social-button nav__social-button--${
                    network.property
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    // trackGAEvent({
                    //   eventCategory: 'Social',
                    //   eventAction: 'Top Nav Follow Us',
                    //   eventLabel: network.property
                    // });
                    this.handleFollowLinkTracking(network, index);
                  }}
                >
                  <i
                    className={`nav__icon nav__icon--${network.property} icon-${
                      network.property
                    }`}
                  />
                </a>
              ))}
            </li>
            <li className="nav__extras-item">
              <button className="queryly_search_button  nav__search-trigger">
                <i className="icon-search-glass" />
              </button>
            </li>
          </ul>
        </div>
        <nav className="nav">
          <ul className="nav__list">
            {topics.map((topic, index) => (
              <li
                key={topic.title}
                className={
                  (topic.removeOnScale
                    ? 'nav__item nav__item__remove'
                    : 'nav__item') + (topic.bold ? ' nav__item__bold' : '')
                }
              >
                {this.renderCategoryLink(topic, index)}
              </li>
            ))}
          </ul>
        </nav>

        {sapSurvey}

        <Search
          skin="light"
          modifier="overlay"
          active={search}
          modal={true}
          closeModal={this.toggleSearchModal}
        />
        <MainMenu
          closeMenu={this.toggleMenu}
          mainMenuVisible={menu}
          scaled={this.state.scale}
          {...mainMenuContext}
          config={config}
          topics={topics}
        />
        {topNewsletterSignup.show ? (
          <div className="topnav-newsletter-container">
            <div className="topnav-newsletter-container__label">
              <span className="topnav-newsletter-container__icon">
                <img
                  alt="logo"
                  src="https://images.fastcompany.net/image/upload/v1559074510/fcweb/DailyCompass_compass_RGB_outlines_yn4acq.svg"
                />
              </span>
              <span className="topnav-sign-up-text">
                Sign up for our daily email.
              </span>
              <span
                className="closeNewsletters"
                onClick={() => {
                  topNewsletterSignup.callback();
                }}
              >
                <img
                  alt="close newsletter"
                  src="https://images.fastcompany.net/image/upload/v1559221848/fcweb/FCCompass_close-x_ruwqtw.svg"
                />
              </span>
            </div>
            <span className="topnav-thank-you-text">
              Thank you for signing up!
            </span>
            <div className="topnav-newsletter-container__form">
              <form
                onChange={() => {
                  const el = document.querySelector(
                    '.topnav-newsletter-container__form'
                  );
                  el.className = 'topnav-newsletter-container__form';
                }}
                onSubmit={event => {
                  const webApiUrl =
                    'https://www.getrevue.co/api/v2/subscribers';
                  const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
                  const submissionStatus = {
                    success: false,
                    response: null
                  };
                  axios
                    .post(
                      webApiUrl,
                      {
                        email: this.state.newsletterEmail,
                        first_name: 'First Name Placeholder',
                        last_name: 'Last Name Placeholder',
                        double_opt_in: false
                      },
                      {
                        headers: {
                          Authorization: `Token ${tokenStr}`
                        }
                      }
                    )
                    .then(response => {
                      // Success
                      submissionStatus.success = true;
                      submissionStatus.response = response;

                      this.newsletterInput.current.setAttribute(
                        'placeholder',
                        `You're signed up!`
                      );
                      this.newsletterInput.current.value = '';
                      this.newsletterInputMobile.current.setAttribute(
                        'placeholder',
                        `You're signed up!`
                      );
                      this.newsletterInputMobile.current.value = '';

                      const successfulSubmission = new EventModel(
                        'Newsletter Submitted Successfully',
                        `Newsletter Submitted Successfully`,
                        'Newsletter Submitted Successfully',
                        `Newsletter Submitted Successfully`
                      );
                      // Track succesful Newsletter signup
                      this.props.trackNewsletterSubmission(
                        successfulSubmission.getTrackingObject()
                      );
                    })
                    .catch(err => {
                      // Fail
                      submissionStatus.response = err;
                      let placeholder =
                        err.response.data.error.email[0] ===
                        'This email address has already been subscribed'
                          ? 'Already subscribed'
                          : err.response.data.error.email[0];
                      placeholder =
                        err.response.data.error.email[0] ===
                          'This is not a valid email address' ||
                        err.response.data.error.email[0] ===
                          "We're really going to need an email address"
                          ? 'Please enter a valid email address'
                          : placeholder;
                      this.newsletterInput.current.setAttribute(
                        'placeholder',
                        placeholder
                      );
                      this.newsletterInputMobile.current.setAttribute(
                        'placeholder',
                        placeholder
                      );
                      this.newsletterInput.current.value = '';
                      this.newsletterInputMobile.current.value = '';
                      const el = document.querySelector(
                        '.topnav-newsletter-container__form'
                      );
                      el.className =
                        'topnav-newsletter-container__form topnav-newsletter-container__form--error';
                    })
                    .then(() => {
                      // Always
                      const submitEvent = new EventModel(
                        'Newsletter Submitted',
                        `Newsletter Submitted`,
                        'Newsletter Submitted',
                        `Newsletter Submitted`
                      );
                      submitEvent.addTrackingAttributes({
                        submissionStatus
                      });
                      if (submissionStatus.success === true) {
                        let el = document.querySelector('.topnav-sign-up-text');
                        el.style.display = 'none';
                        el = document.querySelector('.topnav-thank-you-text');
                        el.style.display = 'block';
                        el = document.querySelector(
                          '.topnav-newsletter-container__form'
                        );
                        el.style.display = 'none';
                        // el = document.querySelector(
                        //   '.topnav-newsletter-container__icon'
                        // );
                        // el.className =
                        //   'topnav-newsletter-container__icon topnav-newsletter-container__icon--mobile-success';
                      }
                      // Track succesful Newsletter click
                      this.props.trackClick(submitEvent.getTrackingObject());
                    });

                  event.preventDefault();
                }}
              >
                <input
                  className="topnav-desktop-input"
                  ref={this.newsletterInput}
                  type="text"
                  placeholder="Enter your email address"
                  onChange={event => {
                    this.newsletterInput.current.setAttribute(
                      'placeholder',
                      'Enter your email address'
                    );

                    this.setState({
                      newsletterEmail: event.target.value
                    });
                  }}
                />
                <input
                  className="topnav-mobile-input"
                  ref={this.newsletterInputMobile}
                  type="text"
                  placeholder="Sign up here for our new daily mail."
                  onChange={event => {
                    this.newsletterInputMobile.current.setAttribute(
                      'placeholder',
                      'Enter your email address'
                    );

                    this.setState({
                      newsletterEmail: event.target.value
                    });
                  }}
                />
                <button type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        ) : null}
        {notification.message ? (
          <Notification
            message={notification.message}
            callback={notification.callback}
          />
        ) : null}
      </header>
    );
  }
}

Nav.defaultProps = {
  trackClick: () => false,
  trackNewsletterSubmission: () => false,
  topNewsletterSignup: {}
};

Nav.propTypes = {
  notification: PropTypes.shape({}).isRequired,
  isHome: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  newsletterLink: PropTypes.string.isRequired,
  trackClick: PropTypes.func,
  trackNewsletterSubmission: PropTypes.func,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool, // eslint-disable-next-line react/no-unused-prop-types
      title: PropTypes.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
      url: PropTypes.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
    })
  ).isRequired,
  config: PropTypes.shape({}).isRequired,
  topNewsletterSignup: PropTypes.shape({})
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject)),
  trackNewsletterSubmission: pageObject =>
    trackEvent(newsletterSubmit(pageObject))
});

const trackedNav = withTracking(mapTrackingToProps)(Nav);

export default trackedNav;
